/* global window */
import axios from './dataSources/default';
import asSofologist from './dataSources/asSofologist';
// services
import { getUserCookies, deleteUserCookies, getSofologistCookie } from './cookieService';
import log from '../utilities/log';
import { exponeaAnonymize } from './exponeaService';
// config
import { config } from '../config';

const URLS = config.URLS;

/**  direct window redirect to login page defined in configs URLS.MY_SOFOLOGY_LOGIN */
export function redirectToLogin() {
  window.location.href = config.URLS.MY_SOFOLOGY_LOGIN;
}

/** get and validate stored user cookie else redirect to login
 *
 * @returns { Promise<Object> } returns user cookies and Authorization information
 *
 */
export function getUserCookieOrSendToLogin() {
  const cookies = getUserCookies();
  if (!cookies) {
    exponeaAnonymize();
    redirectToLogin();
    return false;
  }

  if (!cookies.retailExperienceUser.username || cookies.retailExperienceUser.username === null) {
    cookies.retailExperienceUser.username = cookies.retailExperienceUser.userName;
  }

  let payload = { retailExperienceUser: cookies.retailExperienceUser };

  let sofologistCookie = getSofologistCookie();
  if (sofologistCookie) {
    payload.retailExperienceUser.sofologistToken = sofologistCookie.token;
  }

  return axios.post(`${URLS.MY_SOFOLOGY_API}CookieAuth`, payload)
    .then(res => ({ ...cookies, Authorization: res.data }))
    .catch(() => {
      log.error('00000000-0000-0000-0000-000000000000', 'App failed to generate auth token.');
      // hack.. fix underlyning problem
      try {
        if(cookies && cookies.retailExperienceUser) {
          const retCookie = cookies.retailExperienceUser;
          if(!retCookie.username || retCookie.username === null || !retCookie.token || retCookie.token === null) {
            deleteUserCookies();
          }
        }
      } catch(e) {
        log.error('00000000-0000-0000-0000-000000000000', `failed log in attempt ${JSON.stringify(cookies)}`);
      }
      redirectToLogin();
      return Promise.reject();
    });
}

/** Check wether sofologist is logged in
 *
 * @returns { Promise<Boolean> } returns Promise that resolves to true or false
 * depening on if sofologist is logged in
 *
 */
export function isSofologist() {
  return asSofologist.get(`${URLS.MY_SOFOLOGY_API}impersonation/isSofologist`)
    .catch(() => false);
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js